module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('h4', [_vm._v(_vm._s(_vm.action.label))])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_vm._v(_vm._s(_vm.action.dataLabel) + ":")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end",
    staticStyle: {
      "user-select": "text"
    }
  }, [(_vm.action.enum === 'UPGRADE') ? _c('a', {
    attrs: {
      "href": ("https://" + _vm.network + ".etherscan.io/address/" + (_vm.proposal.data)),
      "title": _vm.proposal.data
    }
  }, [_vm._v("\n            " + _vm._s(_vm.proposal.data.slice(0, 10) + '...') + "\n          ")]) : _c('span', [_vm._v(_vm._s(_vm.proposal.data))])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Author:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v(_vm._s(_vm.proposal.author))])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Voted:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v(_vm._s(_vm.proposal.voted))])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Remaining:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v(_vm._s(_vm.remaining) + " blocks")])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Passing:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v(_vm._s(_vm.proposal.passing))])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Enacted:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v(_vm._s(_vm.proposal.enacted))])], 1), _vm._v(" "), (_vm.active && !_vm.proposal.voted) ? _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.vote(0)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("clear")])], 1)], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.vote(1)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("check")])], 1)], 1)], 1) : (_vm.active && _vm.proposal.voted) ? _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_vm._v("\n          You voted\n        ")])], 1) : (!_vm.active && _vm.proposal.passing && !_vm.proposal.enacted) ? _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "dark": ""
    },
    on: {
      "click": _vm.enact
    }
  }, [_vm._v("enact")])], 1)], 1) : _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_vm._v("\n          Voting has ended. The proposal " + _vm._s(_vm.proposal.passing && _vm.proposal.enacted ? 'passed and has been enacted.' : 'failed.') + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5506bf9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Proposal.vue
// module id = 265
// module chunks = 1